
document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('.custome-gift');

  // ✅ Safety check (important because it's not on all products)
  if (!checkbox) return;

  const select = document.getElementById('custome-box');
  const greetingMyself = document.querySelector('.custom-greeting');
  const recipient = document.querySelector('.custom-recipient');
  const greetingOther = document.querySelector('.custom-greeting-for-other');

  const nameInput = document.getElementById('custome-name');
  const phoneInput = document.getElementById('custome-phone');
  const greetingInputOther = document.getElementById('custom-massage-other');
  const greetingInputMyself = document.getElementById('custom-massage-myself');

  // Helper: safely clear values
  function clearInputs() {
    if (nameInput) nameInput.value = '';
    if (phoneInput) phoneInput.value = '';
    if (greetingInputOther) greetingInputOther.value = '';
    if (greetingInputMyself) greetingInputMyself.value = '';
  }

  // Stage 1 → checkbox toggle
  checkbox.addEventListener('change', function () {
    if (select && select.parentElement) {
      select.parentElement.style.display = checkbox.checked ? 'block' : 'none';
    }

    if (greetingMyself) greetingMyself.style.display = 'none';
    if (recipient) recipient.style.display = 'none';
    if (greetingOther) greetingOther.style.display = 'none';

    if (!checkbox.checked) {
      clearInputs();
    }
  });

  // Stage 2 → dropdown change
  if (select) {
    select.addEventListener('change', function () {
      const value = select.value;

      if (value === 'for-me' || value === 'לעצמי') {
        if (greetingMyself) greetingMyself.style.display = 'block';
        if (recipient) recipient.style.display = 'none';
        if (greetingOther) greetingOther.style.display = 'none';

        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (greetingInputOther) greetingInputOther.value = '';
      }

      else if (value === 'for-others' || value === 'לאחר') {
        if (greetingMyself) greetingMyself.style.display = 'none';
        if (recipient) recipient.style.display = 'block';
        if (greetingOther) greetingOther.style.display = 'block';

        if (greetingInputMyself) greetingInputMyself.value = '';
      }
    });
  }

  // Initialize hidden state (safe)
  if (select && select.parentElement) {
    select.parentElement.style.display = 'none';
  }
  if (greetingMyself) greetingMyself.style.display = 'none';
  if (recipient) recipient.style.display = 'none';
  if (greetingOther) greetingOther.style.display = 'none';
});
/*document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.querySelector('.custome-gift');
  const select = document.getElementById('custome-box');
  const greetingMyself = document.querySelector('.custom-greeting');
  const recipient = document.querySelector('.custom-recipient');
  const greetingOther = document.querySelector('.custom-greeting-for-other');
  const nameInput = document.getElementById('custome-name');
  const phoneInput = document.getElementById('custome-phone');
  const greetingInputOther = document.getElementById('custom-massage-other');
  const greetingInputMyself = document.getElementById('custom-massage-myself');

  // Stage 1 → show select if checkbox checked
  checkbox.addEventListener('change', function() {
    select.parentElement.style.display = checkbox.checked ? 'block' : 'none';
    greetingMyself.style.display = 'none';
    recipient.style.display = 'none';
    greetingOther.style.display = 'none';

    if (!checkbox.checked) {
      nameInput.value = '';
      phoneInput.value = '';
      greetingInputOther.value = '';
      greetingInputMyself.value = '';
    }
  });

  // Stage 2 → handle dropdown change
  select.addEventListener('change', function() {
    const value = select.value;

    if (value === 'for-me' || value === 'לעצמי') {
      // Show only greeting for myself
      greetingMyself.style.display = 'block';
      recipient.style.display = 'none';
      greetingOther.style.display = 'none';

      // Clear other inputs
      nameInput.value = '';
      phoneInput.value = '';
      greetingInputOther.value = '';
    } else if (value === 'for-others' || value === 'לאחר') {
      // Show name + phone + greeting immediately
      greetingMyself.style.display = 'none';
      recipient.style.display = 'block';
      greetingOther.style.display = 'block';

      // Clear myself greeting
      greetingInputMyself.value = '';
    }
  });

  // Initialize hidden sections
  select.parentElement.style.display = 'none';
  greetingMyself.style.display = 'none';
  recipient.style.display = 'none';
  greetingOther.style.display = 'none';
});*/
